<template>
   <b-container>
      <b-card no-body>
         <b-card-header header-tag="nav">
            <b-nav class="card-header-tabs" card-header tabs >
            </b-nav>
         </b-card-header>
         <b-card-body>
            <pb-spinner v-if="busy"/>
            <b-input-group class="mb-3">
               <b-form-input v-model="filter" placeholder="Filter by ID, name or number..." />
               <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
               </b-input-group-append>
            </b-input-group>
            <b-table responsive striped hover small :items="colorCards"
                     :fields="fields" :filter="filter" :filter-included-fields="['qualitaetId', 'qualitaet', 'qualitaetnummer']">
               <template v-slot:cell(actions)="row">
                  <b-button variant="link" title="Show Colors" @click="showDetail(row.item)">
                     <i class="fal fa-palette"></i>
                  </b-button>
                  <b-button variant="link" title="Generate QR Code" @click="showQrCode(row.item)">
                     <i class="fal fa-qrcode"></i>
                  </b-button>
               </template>
            </b-table>
            <b-modal
                id="qrCodeModal"
                ref="qrCodeModal"
                ok-only
                :title="'QR Code - ' + (selectedItem ? selectedItem.qualitaet : '')">
               <div class="text-center">
                  <img v-if="qrCodeDataUrl" :src="qrCodeDataUrl" alt="QR Code"/>
                  <p class="mt-3" v-if="selectedItem">{{ qrCodeUrl }}</p>
               </div>
            </b-modal>
            <b-modal
                id="detailModal"
                ref="detailModal"
                size="xl"
                ok-only
                :title="detailItem ? detailItem.qualitaet + ' (' + detailItem.qualitaetnummer + ')' : 'Colors'">
               <pb-spinner v-if="detailBusy"/>
               <b-row v-if="detailColors.length > 0">
                  <b-col v-for="(color, index) in detailColors" :key="index" cols="6" sm="4" md="3" lg="2" class="mb-3">
                     <b-card no-body class="h-100 text-center">
                        <img v-if="color.foto" :src="imageResource(color.foto, 240)" class="card-img-top p-2" style="object-fit: contain; height: 120px;" alt="color"/>
                        <div v-else class="d-flex align-items-center justify-content-center" style="height: 120px; background: #f5f5f5;">
                           <i class="fal fa-image fa-2x text-muted"></i>
                        </div>
                        <b-card-body class="p-2">
                           <strong>{{ color.farbnummer }}</strong>
                           <small v-if="color.farbnotiz" class="d-block text-muted">{{ color.farbnotiz }}</small>
                        </b-card-body>
                     </b-card>
                  </b-col>
               </b-row>
               <b-alert v-else-if="!detailBusy" variant="info" show>No colors available.</b-alert>
            </b-modal>
         </b-card-body>
      </b-card>
   </b-container>
</template>
<script>
    import ArticleApi from "../../../shared/_api/article";
    import QRCode from 'qrcode';

    export default {
        name: 'color-cards',
        data: function () {
            return {
                colorCards: [],
                busy: false,
                filter: '',
                selectedItem: null,
                qrCodeDataUrl: null,
                qrCodeUrl: '',
                detailItem: null,
                detailColors: [],
                detailBusy: false,
                fields: [
                    'qualitaetId',
                    'qualitaet',
                    'qualitaetnummer',
                    { key: 'actions', class: 'table-action-column' }
                ]
            }
        },
        methods: {
            showDetail: function (item) {
                this.detailItem = item;
                this.detailColors = [];
                this.detailBusy = true;
                this.$bvModal.show('detailModal');
                ArticleApi.farbkarteByQualitaetId(item.qualitaetId).then(data => {
                    this.detailColors = data.farben || [];
                }).catch(err => {
                    this.$bvToast.toast(`Error loading colors: ${err.message}`, this.$toastDanger);
                }).finally(() => {
                    this.detailBusy = false;
                });
            },
            showQrCode: function (item) {
                this.selectedItem = item;
                this.qrCodeUrl = `${window.location.origin}/color-card/${item.qualitaetId}`;
                QRCode.toDataURL(this.qrCodeUrl, { width: 300 }).then(url => {
                    this.qrCodeDataUrl = url;
                    this.$bvModal.show('qrCodeModal');
                }).catch(err => {
                    this.$bvToast.toast(`Error generating QR code: ${err.message}`, this.$toastDanger);
                });
            }
        },
        created: function () {
            this.busy = true;
            ArticleApi.farbkarteList().then(data => {
                this.colorCards = data;
            }).catch(e => {
                this.$bvToast.toast(`Error loading color cards: ${e.message}`, this.$toastDanger);
            }).finally(() => {
                this.busy = false;
            });
        }
    }
</script>
